import { Grid } from "@mui/material";
import React from "react";
import DailyChartWrapper from "./DailyChartWrapper";
import HourlyChartWrapper from "./HourlyChartWrapper";

function ChartPage() {
  return (
    <Grid container spacing={2} alignItems="center" justifyContent="center">
      <Grid item xs={0.5}></Grid>
      <Grid item xs={5.5}>
        <DailyChartWrapper day={28} />
      </Grid>
      <Grid item xs={5.5}>
        <HourlyChartWrapper day={28} />
      </Grid>
      <Grid item xs={0.5}></Grid>
    </Grid>
  );
}
export default ChartPage;
